import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './CenteredContent.module.css'

interface CenteredContentProps {
  className?: string
  children?: ReactNode
}

/**
 * Centers its children in the available space.
 */
export function CenteredContent({ className, children }: CenteredContentProps) {
  return <div className={cx(styles.root, className)}>{children}</div>
}
